/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "@/api/fetchClient.js";
import type { ResearchChatControllerUpdateSessionMutationRequest, ResearchChatControllerUpdateSessionMutationResponse, ResearchChatControllerUpdateSessionPathParams, ResearchChatControllerUpdateSession400, ResearchChatControllerUpdateSession401, ResearchChatControllerUpdateSession403, ResearchChatControllerUpdateSession404, ResearchChatControllerUpdateSession409, ResearchChatControllerUpdateSession500 } from "../types/ResearchChatControllerUpdateSession.js";
import type { Client, RequestConfig, ResponseErrorConfig } from "@/api/fetchClient.js";

function getResearchChatControllerUpdateSessionUrl(sessionId: ResearchChatControllerUpdateSessionPathParams["sessionId"]) {
  const res = { method: 'PATCH', url: `/api/research-chat/${sessionId}` as const }
  return res
}

/**
 * @description Updates the session properties such as title.
 * @summary Update a chat session
 * {@link /api/research-chat/:sessionId}
 */
export async function researchChatControllerUpdateSession(sessionId: ResearchChatControllerUpdateSessionPathParams["sessionId"], data: ResearchChatControllerUpdateSessionMutationRequest, config: Partial<RequestConfig<ResearchChatControllerUpdateSessionMutationRequest>> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config

  const requestData = data

  const res = await request<ResearchChatControllerUpdateSessionMutationResponse, ResponseErrorConfig<ResearchChatControllerUpdateSession400 | ResearchChatControllerUpdateSession401 | ResearchChatControllerUpdateSession403 | ResearchChatControllerUpdateSession404 | ResearchChatControllerUpdateSession409 | ResearchChatControllerUpdateSession500>, ResearchChatControllerUpdateSessionMutationRequest>({ method : "PATCH", url : getResearchChatControllerUpdateSessionUrl(sessionId).url.toString(), data : requestData, ... requestConfig })
  return res.data
}